import './app/publicPath'

const Vue = window.Vue
Vue.component('SearchOSInput', () => import('./app/SearchOSInput.vue'))
Vue.component('SearchOSFilter', () => import('./app/SearchOSFilter.vue'))
Vue.component('SearchOSTagList', () => import('./app/SearchOSTagList.vue'))
